import React from "react";
import me from "../assets/me.jpg";
import { FaLinkedin } from "react-icons/fa";
import { FaGithubSquare } from "react-icons/fa";
import { SiNetlify } from "react-icons/si";
import Pagetransition from "./pagetransition";
function Home() {
  return (
    <Pagetransition>
      <section className="home container">
        <div>
          <div className="home_container">
            <h4>Hello I'm</h4>
            <h1>Zakaria Hizzi</h1>
            <div className="me">
              <img src={me} alt="" />
            </div>
            <h4 className="text-light">Frontend developer</h4>

            <a href="#contact" className="btn">
              let's to talk
            </a>
            <div className="social-icons">
              <a href="https://github.com/ZakariaHizzi" target="_blank">
                <FaGithubSquare />
              </a>
              <a
                href="https://www.linkedin.com/in/zakaria-hizzi-3234a9297/"
                target="_blank"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>
      </section>
    </Pagetransition>
  );
}

export default Home;
